import { StandardLink } from "@components/Link/StandardLink";
import { getInternalOrExternalIcon } from "@utils/linkIconHelper";

import { Context } from "types/context/Context";

import { LinkBlockType_link } from "./queries/contentfulTypes/LinkBlockType";

const getButtonClassName = (buttonVariant: string) =>
  buttonVariant === "Sekundär" ? "secondary" : "primary";

interface ILinkProps {
  blockData?: LinkBlockType_link;
  uniqueKey?: string;
  context?: Context;
  isBarker?: boolean;
}

const index = ({ blockData: linkBlock, context, isBarker }: ILinkProps) => {
  const url = linkBlock?.url;
  const externalReference = linkBlock?.url;
  const globalLink = linkBlock?.globalLinkItem;
  const barker =
    isBarker || linkBlock?.globalLinkItem?.key.includes("Anmälningslänk") ? "barker" : undefined;
  const internalReference = linkBlock?.reference;
  const linkVariant = linkBlock?.variant?.toLowerCase() === "knapp" ? "button" : "link";
  const buttonStyle =
    linkVariant === "button" ? getButtonClassName(linkBlock?.buttonVariant) : null;
  const linkType = getInternalOrExternalIcon(externalReference, internalReference, globalLink);
  const target =
    externalReference?.includes("mailto:") || externalReference?.includes("tel:")
      ? "_self"
      : linkBlock?.newTab
        ? "_blank"
        : "_self";

  return (
    <StandardLink
      type={linkType}
      text={linkBlock?.linkText}
      buttonStyle={buttonStyle}
      href={url}
      variant={linkVariant}
      target={target}
      contentfulEntryId={linkBlock.sys?.id}
      contentfulFieldId="name"
      trackingData={{
        sectionTitle:
          context?.accordionHeading ??
          context?.sectionBlock?.sectionBlockHeading ??
          context?.pageHeading,
        sectionBlockIndex: context?.sectionBlock?.sectionBlockIndex,
        linkType: barker,
        insurance: context?.insuranceName || undefined,
      }}
    />
  );
};
export default index;
